import React from 'react';
import ModalLayout from '../ModalLayout';
import { useTranslation } from 'react-i18next';
import ChannelInfo from '../Channel/ChannelInfo';
import { buttonStyles, redButtonStyles } from '../../styles/commonStyles';

const LeaveChannelModal = ({ isOpen, onClose, onLeave, channelTitle, channelDescription }) => {
    const { t } = useTranslation();

    return (
        <ModalLayout isOpen={isOpen} onClose={onClose}>
            <div className="mb-4">
                <ChannelInfo title={channelTitle} description={channelDescription} showStatistic={false} />
            </div>
            <p className="mb-4 text-center">{t("UI.Modals.LeaveChannelModal.confirmationMessage")}</p>
            <div className="flex justify-end space-x-2">
                <button onClick={onClose} className={buttonStyles}>
                    {t("cancel")}
                </button>
                <button onClick={onLeave} className={redButtonStyles}>
                    {t("UI.Modals.LeaveChannelModal.leaveButton")}
                </button>
            </div>
        </ModalLayout>
    );
};

export default LeaveChannelModal;
